import { Controller } from "@hotwired/stimulus"
import { toast } from "../lib/toast"

// サーバー側のメッセージを右スライドインのトーストで出すためのブリッジ。
// Turbo Stream の append や HTML 描画で <div data-controller="toast-notice" ...> を差し込むと、
// connect 時に toast() を呼び、自分自身は DOM から取り除く(= 表示位置に依存しない)。
//
// 使い方(view): render "ai_visibility_projects/toast", message: "保存しました", type: "success"
export default class extends Controller {
  static values = {
    message: String,
    type: { type: String, default: "success" },
    sticky: { type: Boolean, default: false },
  }

  connect() {
    if (this.messageValue) {
      toast(this.messageValue, this.typeValue, this.stickyValue ? { duration: 0 } : {})
    }
    this.element.remove()
  }
}
